import AddIcon from '@mui/icons-material/Add'
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem } from "@mui/material";
import NoDataImg from "../../../assets/img/no-data.gif";
import Switch from "@mui/material/Switch";
import Button from '@mui/material/Button'
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import Dropdown from "react-bootstrap/Dropdown";
import Box from "@mui/material/Box";
import { v4 as uuidv4 } from 'uuid';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import dayjs from 'dayjs'
import { useCallback, useEffect, useReducer, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    updateTopHeader,
    updateLoading
} from '../../../redux/features/common/commonSlice'
import ApiCaller from '../../constants/ApiCaller'
import urls from '../../constants/apiurl'
import { showDangerToast, showToast } from '../../constants/toaster'
import NavBar from '../../structure/NavBar'
import { NavBarTop } from '../../structure/NavBarTop'
import { Pagination } from '@mui/material';
import InsufficientPermission from '../../custom/InSufficientPermission';
import { AddNetworkProvider } from './AddNetworkProvider';
import Utils from '../../constants/Utils';
import { useNavigate } from 'react-router-dom'
const label = { inputProps: { 'aria-label': 'Size switch demo' } }
export const NetworkProviersList = props => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedData, setSelectedData] = useState({});
    const open = Boolean(anchorEl);
    const { formatDate } = Utils();
    const [searchText, setSearchText] = useState('')
    const [statusDropdownText, setStatusDropdownText] = useState('Select Status')
    const [addNewNotification, setAddNewNotification] = useState(false)
    const [networkProviderDetails, setNetworkProviderDetails] = useState({})
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [value, setValue] = useState(dayjs())
    const [callAPi, setCallAPi] = useState('')
    const LOADING_ENABLE = useSelector(state => state?.loading)
    const userData = useSelector(state => state?.userData)
    const [showAddRole, setShowAddRole] = useState(false)
    const [datalist, setDatalist] = useState([])
    const [sort_type, setSortType] = useState('createdAt')
    const [sort_order, setSortOrder] = useState(false)
    const [page, setPage] = useState(1)
    const [pagerecord, setPagerecord] = useState({
        totalItems: 0,
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1
    })

     const userPermisiions = useSelector(state => state?.permission)
    let currentModulePermission;
    let viewPermission = true;
    let editPermission = true;
    let deletePermissionVal = true;
    let activePermission = true;

    // Function to fetch data - extracted for reusability
    const fetchNetworkProviders = async (pageNum = page) => {
        try {
            const token = userData?.access_token;
            if (!token) {
                navigate('/login');
                return;
            }

            setLoading(true);
            dispatch(updateLoading(true));
            setError(null);

            const postJson = {
                searchText: searchText?.trim(),
                pageNum: pageNum - 1,
                pageSize: 10,
                shortingField: sort_type,
                active: statusDropdownText === "Active" 
                    ? true 
                    : statusDropdownText === "In Active" 
                    ? false 
                    : null,
                asc: sort_order,
                countryId: '',
                paid: null
            };

            const path = urls.networkServiceProviderList;
            const res = await ApiCaller.post(postJson, path, token);
            const response = await res.response.json();

            if (response.status === 200 || response.status === '200') {
                setDatalist(response?.data?.items || []);
                setPagerecord({
                    totalItems: response?.data?.totalItems || 0,
                    totalPages: response?.data?.totalPages || 1,
                    pageNumber: pageNum,
                    pageSize: 10
                });
            } else if (response.status === 401 || response.status === '401') {
                // Unauthorized - redirect to login
                navigate('/login');
            } else {
                setError(response.message);
                showDangerToast(response.message);
            }
        } catch (error) {
            console.error('Error fetching network providers:', error);
            if (error.message?.includes('401') || error.message?.includes('unauthorized')) {
                navigate('/login');
            } else {
                setError(error.message);
                showDangerToast(error.message || 'Failed to fetch network providers');
            }
        } finally {
            setLoading(false);
            dispatch(updateLoading(false));
        }
    }

    // Handle page change
    const handleChange = async (event, newPage) => {
        setPage(newPage)
        await fetchNetworkProviders(newPage)
    }

    // Handle filter click
    const handleFilterClick = async () => {
        setPage(1)
        await fetchNetworkProviders(1)
    }

    // Handle filter reset
    const handleResetFilter = async () => {
        setStatusDropdownText("Select Status")
        setSearchText("")
        setPage(1)
        await fetchNetworkProviders(1)
    }

    // Handle status change
    const handleStatusChange = async (event, id) => {
        try {
            setLoading(true)
            dispatch(updateLoading(true))
            setError(null)

            const path = urls.changeLanguageStatus + "/" + id
            const res = await ApiCaller.put({}, path, userData?.access_token)
            const response = await res.response.json()

            if (response.status === 200) {
                showToast(response?.message)
                await fetchNetworkProviders(page)
            } else {
                setError(response.message)
                showDangerToast(response.message)
            }
        } catch (error) {
            setError(error.message)
            showDangerToast(error.message)
            console.error('Error changing status:', error)
        } finally {
            setLoading(false)
            dispatch(updateLoading(false))
        }
    }

    const handleClose = () => {
        setAnchorEl(null);
    };
    
    // Handle click for menu
    const handleClick = (event, item) => {
        setAnchorEl(event.currentTarget);
        setSelectedData(item);
    };

    // Handle edit network provider
    const handleEditNetworkProvider = (item) => {
        handleClose();
        setNetworkProviderDetails(item);
        setAddNewNotification(true);
    };

    // Check authentication on mount
    useEffect(() => {
        const checkAuth = () => {
            const token = localStorage.getItem('userToken');
            const userData = localStorage.getItem('userData');
            
            if (!token || !userData) {
                navigate('/login');
                return;
            }
            
            // Update header only if authenticated
            dispatch(updateTopHeader('Network Provider Manager'));
        };
        
        checkAuth();
    }, []);

    // Initialize data and cleanup
    useEffect(() => {
        if (viewPermission && userData?.access_token) {
            fetchNetworkProviders()
        }

        return () => {
            // Cleanup
            setDatalist([])
            setPage(1)
            setError(null)
        }
    }, [viewPermission, userData])

    // Handle search/filter changes with auth check
    useEffect(() => {
        if (!userData?.access_token) return;

        const timer = setTimeout(() => {
            if (viewPermission && callAPi) {
                fetchNetworkProviders()
            }
        }, 500) // Debounce searches

        return () => clearTimeout(timer)
    }, [callAPi, viewPermission, userData])


    if (userPermisiions?.modules.length > 0) {
        currentModulePermission = userPermisiions.modules.find((element) => {
            if (element.moduleId === '14') {
                return element
            }
        })?.permissions
        viewPermission = currentModulePermission.find((element) => {
            if (element.name === 'VIEW') {
                return element
            }
        }).isEnable
        editPermission = currentModulePermission.find((element) => {
            if (element.name === 'EDIT') {
                return element
            }
        }).isEnable
        deletePermissionVal = currentModulePermission.find((element) => {
            if (element.name === 'DELETE') {
                return element
            }
        }).isEnable
        activePermission = currentModulePermission.find((element) => {
            if (element.name === 'ACTIVE') {
                return element
            }
        }).isEnable
    }

    return (
        <>
            <NavBar />
            <div className='main-content'>
                <NavBarTop />
                <div className='header'>
                    <div className='logo'>
                        <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
                    </div>
                </div>
                {
                    viewPermission ? (<>
                        {addNewNotification ? (
                            <AddNetworkProvider
                                setAddNewNotification={setAddNewNotification}
                                setCallAPi={setCallAPi}
                                networkProviderDetails={networkProviderDetails}
                            />
                        ) : (
                            <div className='container-fluid mt--7'>
                                <div className='row'>
                                    <div className='col text-left'>
                                        <div className='card shadow'>
                                            <div className='card-header border-0'>
                                                <div className='row align-items-center text-left'>
                                                    <div className='col'>
                                                        <h3 className='mb-0'>Network Providers List</h3>
                                                    </div>
                                                    {
                                                        editPermission &&
                                                        <div className='col text-right'>
                                                            <a
                                                                onClick={() => {
                                                                    setAddNewNotification(true)
                                                                    setNetworkProviderDetails(null)
                                                                }}
                                                                className='btn btn-sm btn-primary text-white'
                                                            >
                                                                <AddIcon />
                                                                Add Network Provider
                                                            </a>
                                                            {/* <a href='#!' className='btn btn-sm btn-primary'>
                    See all
                  </a> */}
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="card-header border-0">
                                                <div className="row align-items-center text-left">
                                                    <div className="col-md-3">
                                                        <InputGroup
                                                            className="mb-2"
                                                            style={{ borderRadius: "10px" }}
                                                        >
                                                            <Form.Control
                                                                placeholder="Search by Name"
                                                                value={searchText}
                                                                onChange={(e) => setSearchText(e.target.value)}
                                                                aria-label="Amount (to the nearest dollar)"
                                                            />
                                                        </InputGroup>
                                                    </div>
                                                    <div className="col-md-2 mb-2 " style={{ marginRight: "30px" }}>
                                                        <Dropdown>
                                                            <Dropdown.Toggle
                                                                variant="success"
                                                                style={{
                                                                    backgroundColor: "white",
                                                                    color: "black",
                                                                    border: "1px solid #cad1d7",
                                                                    boxShadow: "none",
                                                                    transform: "none",
                                                                }}
                                                                id="dropdown-basic"
                                                            >
                                                                {statusDropdownText}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                <Dropdown.Item
                                                                    onClick={() =>
                                                                        setStatusDropdownText("Select Status")
                                                                    }
                                                                >
                                                                    Select Status
                                                                </Dropdown.Item>
                                                                <Dropdown.Item
                                                                    onClick={() => setStatusDropdownText("Active")}
                                                                >
                                                                    Active
                                                                </Dropdown.Item>
                                                                <Dropdown.Item
                                                                    onClick={() => setStatusDropdownText("In Active")}
                                                                >
                                                                    In Active
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                    <div className="col-md-4 mb-2">
                                                        <Button
                                                            variant="contained"
                                                            className="custom-filter-btn"
                                                            onClick={handleFilterClick}
                                                        >
                                                            Filter
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            className="ml-2 custom-filter-btn"
                                                            onClick={handleResetFilter}
                                                        >
                                                            Reset
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="table-responsive">
                                                {datalist && datalist?.length > 0 ? (
                                                    <>
                                                        <table className="table align-items-center table-flush">
                                                            <thead className="thead-light">
                                                                <tr>
                                                                    <th scope="col">S/No.</th>
                                                                    <th scope="col">Country</th>
                                                                    <th scope="col">ISP</th>
                                                                    <th scope="col">Paid</th>
                                                                    <th scope="col">Status</th>
                                                                    {(editPermission || deletePermissionVal) && <th scope="col" >Action</th>}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {datalist &&
                                                                    datalist?.map((data, i) => {
                                                                        const startIndex = (pagerecord.pageNumber - 1) * pagerecord.pageSize;
                                                                        return (

                                                                            <>
                                                                                <tr key={i}>
                                                                                    <td>{startIndex + i + 1}</td>
                                                                                    <td>{data?.countryName}</td>
                                                                                    <td>{data?.isp}</td>
                                                                                    <td>
                                                                                        {data?.paid ? 'Paid' : 'Free'}
                                                                                    </td>
                                                                                    <td>
                                                                                        {userData.admin ? (
                                                                                            <Switch
                                                                                                {...label}
                                                                                                checked={data?.active}
                                                                                                onChange={(e) =>
                                                                                                    handleStatusChange(e, data?.id)
                                                                                                }
                                                                                                size="small"
                                                                                            />
                                                                                        ) : viewPermission ? (
                                                                                            <Switch
                                                                                                {...label}
                                                                                                checked={data?.active}
                                                                                                disabled={!activePermission}
                                                                                                onChange={(e) =>
                                                                                                    handleStatusChange(e, data?.id)
                                                                                                }
                                                                                                size="small"
                                                                                            />
                                                                                        ) : (
                                                                                            <></>
                                                                                        )}
                                                                                    </td>
                                                                                    {
                                                                                        (editPermission || deletePermissionVal) &&
                                                                                        <td className='text-right'>
                                                                                            <IconButton size="small" onClick={(e) => handleClick(e, data)}>
                                                                                                <MoreVertIcon />
                                                                                            </IconButton>
                                                                                            <Menu
                                                                                                anchorEl={anchorEl}
                                                                                                open={open}
                                                                                                onClose={handleClose}
                                                                                                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                                                                transformOrigin={{ vertical: "top", horizontal: "right" }}
                                                                                            >
                                                                                                {(userData.admin || editPermission) && (
                                                                                                    <MenuItem
                                                                                                        onClick={() => handleEditNetworkProvider(selectedData)}
                                                                                                    >
                                                                                                        Edit
                                                                                                    </MenuItem>
                                                                                                )}
                                                                                            </Menu>
                                                                                        </td>
                                                                                    }
                                                                                </tr>
                                                                            </>
                                                                        );
                                                                    })}
                                                            </tbody>
                                                        </table>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="text-center">
                                                            <img width={"25%"} src={NoDataImg}></img>
                                                            <br />
                                                            <label style={{ fontWeight: 'bold' }}>
                                                                {LOADING_ENABLE ? <>Loading Data.....</> : <>No Data Found</>}
                                                            </label>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                            {datalist && datalist.length > 0 ? (
                                                <>
                                                    <div className="card-footer py-4">
                                                        <Box display="flex" justifyContent="right" alignItems='center'>
                                                            <span>Total record: {pagerecord?.totalItems}</span>
                                                            <Pagination
                                                                className="custom-pagination-class"
                                                                count={pagerecord?.totalPages}
                                                                page={page}
                                                                onChange={handleChange}
                                                                color="secondary"
                                                            />
                                                        </Box>
                                                    </div>
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>) : (<InsufficientPermission />)
                }
            </div>
        </>
    )
}
